import React from 'react'
import InputMask from 'react-input-mask';

const InputProfile = ({name,mask,type,onChange,onBlur,value,error,messageError,maxLength}) => {

    
    const input = {

        width:"291px",
        height:"45px",
        borderRadius:"7px",
        border:"1px solid #D7D7D7",
        outline:"none",
        paddingLeft:"0.813rem",
        marginRight:"20px"
  
      }
  

    return(

        mask == true 
        
        ?
        <div style={{display:"flex",flexDirection:"column",position:"relative"}}>
        <label style={{marginBottom:"14px"}}>{name}</label>
        <InputMask mask={type} maskChar={false} onBlur={onBlur}  type={type} value={value} onChange={onChange} style={input}/>
        {error != undefined 
        
        ?
        <p style={{position:"absolute",color:"red",top:"70px"}}>{messageError}</p>
        :
        <></>
        }
        </div>
        :

        <div style={{display:"flex",flexDirection:"column",position:"relative",marginBottom:"10px"}}>
        <label style={{marginBottom:"8px"}}>{name}</label>
        <input onChange={onChange} maxLength={maxLength} value={value} type={type}  onBlur={onBlur} style={input}/>
        {error != undefined 
        
        ?
        <p style={{position:"absolute",color:"red",top:"70px"}}>{messageError}</p>
        :
        <></>
        }
        </div>
    )

}
export default InputProfile